exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table[data-v-6f254718]{width:100%;position:relative}.table .cln-check[data-v-6f254718]{width:50px;min-width:50px}.table .cln-name[data-v-6f254718]{-ms-flex-positive:1;flex-grow:1}.table .cln-contrat[data-v-6f254718],.table .cln-salarie[data-v-6f254718]{width:150px;min-width:150px}.table .tbody[data-v-6f254718]{height:400px}.table .tbody .cln-check[data-v-6f254718]{cursor:pointer;transition-property:background-color;transition-duration:.2s}.table .tbody .cln-check[data-v-6f254718]:hover{background-color:#d0f6ec}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-6f254718","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/modalComponents/modalSalaries/modalSalaries.scss
// module id = Z38i
// module chunks = 2